import { SearchOutlined } from '@ant-design/icons'
import { Button, Input, Tooltip } from 'antd'
import { FC } from 'react'
import { useSearchDialog } from './context'

const SearchDialogButton: FC<{ triggerDisplayMode?: 'icon' | 'input' }> = ({
  triggerDisplayMode = 'icon',
}) => {
  const { setIsVisible } = useSearchDialog()

  return (
    <>
      {triggerDisplayMode == 'icon' && (
        <Tooltip title="Search (Press ⌘ + K)">
          <Button
            type="text"
            icon={<SearchOutlined />}
            onClick={() => setIsVisible(true)}
            style={{ outline: 'none' }}
          />
        </Tooltip>
      )}
      {triggerDisplayMode == 'input' && (
        <Input
          style={{ width: '100%', maxWidth: 500 }}
          placeholder="Search anything"
          allowClear
          size="large"
          onFocus={(e) => {
            e.target.blur()
            setIsVisible(true)
          }}
        />
      )}
    </>
  )
}

type SearchDialogButtonType = { Button: typeof SearchDialogButton }

export { SearchDialogButton, type SearchDialogButtonType }
